<script lang="ts">

  import LinkedRangeControls from './components/LinkedRangeControls.svelte';
  import type { LinkedRangeControlsPayload } from './components/types/linked-range-controls-payload';
  import { createEventDispatcher } from 'svelte';
  import type { FilterValue } from './global';

  const areaMin = 39;
  const areaMax = 102;
  const areaStep = 1;
  const roomsMin = 2;
  const roomsMax = 5;
  const roomsStep = 1;
  const floorMin = 0;
  const floorMax = 5;
  const floorStep = 1;

  let filterValue: FilterValue = {
    floor: {min: 0, max: 5},
    roomsRange: {min: 2, max: 5},
    area: {min: 39, max: 102},
  }

  const onFloorChange = (event: CustomEvent<LinkedRangeControlsPayload>) => {
    filterValue = {...filterValue, floor: {min: event.detail.minValue, max: event.detail.maxValue}};
  }

  const onRoomsChange = (event: CustomEvent<LinkedRangeControlsPayload>) => {
    filterValue = {...filterValue, roomsRange: {min: event.detail.minValue, max: event.detail.maxValue}};
  }

  const onAreaChange = (event: CustomEvent<LinkedRangeControlsPayload>) => {
    filterValue = {...filterValue, area: {min: event.detail.minValue, max: event.detail.maxValue}};
  }

  const dispatch = createEventDispatcher<{filterValue: FilterValue}>();

  const doFilter = () => {
    dispatch('filterValue', filterValue);
  }
</script>

<div class="container-fluid">
  <div class="row align-items-center">
    <div class="row">
      <div class="col-12 col-md-8">
        <LinkedRangeControls min={floorMin} max={floorMax} step={floorStep}
                             minValue={filterValue.floor.min} maxValue={filterValue.floor.max}
                             on:valueChange={onFloorChange}>
          <span slot="left">Piętro min</span>
          <span slot="right">Piętro max</span>
        </LinkedRangeControls>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8">
        <LinkedRangeControls min={roomsMin} max={roomsMax} step={roomsStep}
                             minValue={filterValue.roomsRange.min} maxValue={filterValue.roomsRange.max}
                             on:valueChange={onRoomsChange}>
          <span slot="left">Pomieszczenia min</span>
          <span slot="right">Pomieszczenia max</span>
        </LinkedRangeControls>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8">
        <LinkedRangeControls min={areaMin} max={areaMax} step={areaStep} minDiff={1}
                             minValue={filterValue.area.min} maxValue={filterValue.area.max}
                             on:valueChange={onAreaChange}>
          <span slot="left">Powierzchnia min</span>
          <span slot="right">Powierzchnia max</span>
        </LinkedRangeControls>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4">
        <button class="btn btn-primary" type="button" on:click={doFilter}>Filtruj</button>
      </div>
    </div>
  </div>
</div>
